import { notification } from 'antd'
import { COLORS } from 'constants/colors'
import { ROUTE_PATH } from 'routes'

export const sendSomethingWrongNotification = (customMessage?: string) => {
  notification.config({ maxCount: 1 })
  notification.error({
    message: customMessage || 'Something went wrong!',
    description: (
      <>
        Please check your connection and try again, or{' '}
        <a
          style={{ color: COLORS.primary.medium }}
          href={`${process.env.REACT_APP_URL}${ROUTE_PATH.SUPPORT}`}
          target="_blank"
          rel="noreferrer"
        >
          contact support
        </a>
        .
      </>
    ),
  })
}
